
import { IconLibrary } from "@/interfaces/IconLibrary";
import { IconMapper } from "./IconPaths";



export function getIconPaths(icon: IconLibrary): string {
  return IconMapper[icon];
}


// Extract the path data from each match and remove HTML markup
export function parseIconPaths(svgPaths: string) {
  const pathMatches = svgPaths.match(/<path([^>]*)\/>/g);

  if (!pathMatches) {
    return [];
  }

  const pathElements = pathMatches.map((match) => {
    const pathDataMatch = match.match(/d="([^"]+)"/);
    const fillRule = match.match(/fillRule="([^"]+)"/)
    const clipRule = match.match(/clipRule="([^"]+)"/)

    if (pathDataMatch?.[1]) {
      return [pathDataMatch[1], fillRule?.[1], clipRule?.[1]]
    }
  });

  return pathElements;
}

//get IconLibrary Name for List Items
export function getListIconLibrary(itemType: string) {
  switch (itemType.toLowerCase()) {
    case "list":
      return IconLibrary.LIST;
    case "page":
        return IconLibrary.LIST_ITEM
    case "web":
      return IconLibrary.WEBPAGE
    case "image":
     return IconLibrary.IMAGE
    case "video":
      return IconLibrary.VIDEO
    case "file":
      return IconLibrary.LIST_ITEM
    case "contact":
      return IconLibrary.CONTACT
    case "rss":
      return IconLibrary.RSS
    case "audio":
      return IconLibrary.AUDIO
    default:
      return IconLibrary.IMAGE_UPLOAD;
  }
}
